import React from 'react';
import { Box } from '@mui/joy';
import SEO from '../components/common/SEO';
import AppleStyleScroll from '../components/home/AppleStyleScroll';

const LandingPage = () => {
    return (
        <>
            <SEO 
                title="Hubitable - AI-Powered Fitness Program & Healthy Diet Platform"
                description="Transform your lifestyle with Hubitable's personalized fitness program and healthy diet planning. Our AI-powered platform connects you with gyms, nutrition experts, and wellness services."
            />
            
            <Box>
                {/* Apple-style scroll experience with integrated footer */}
                <AppleStyleScroll />
            </Box>
        </>
    );
};

export default LandingPage; 